module.exports = __webpack_public_path__ + "static/p1-6ec892051f5a34b4b5caf8b61d1d72ee.jpg";